module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/png/vision_lv-0514edd5bcc55dbd3bf4a09e88158a9c.png";